module.exports = __webpack_public_path__ + "static/media/dec 2021.1ba16543.svg";